<div class="d-flex flex-column">
  <div
    [style.background-image]="backgroundUrlFromDb"
    [ngClass]="{
      'parallax-section-1': backgroundUrlFromDb,
      'content-footer': !backgroundUrlFromDb && webFooterLogoExists,
      'content-no-footer': !backgroundUrlFromDb && !webFooterLogoExists,
    }"
  >
    <div class="backdrop">
      <div class="container pt-2">
        <div class="d-flex flex-row flex-wrap justify-content-center mask mx-2">
          <div
            class="col align-self-center text-center d-flex justify-content-center"
          >
            @if (mainPortalData?.logoUrl) {
              <img
                src="{{ mainPortalData?.logoUrl }}"
                class="main-portal-logo-max-width d-none d-md-block"
                alt="{{ mainPortalData?.name }}-logo"
              />
            }
          </div>
          <div class="col-8 mt-2">
            @if (webCmsCountiesHeaderText) {
              <div
                class="jumbotron jumbotron-fluid text-center pt-1 pb-0 mb-0 pok-jumbotron"
              >
                <div
                  [innerHTML]="webCmsCountiesHeaderText"
                  class="webCmsCountiesHeaderText"
                ></div>
              </div>
            }
          </div>
          <div class="col"></div>
        </div>
      </div>
      <div class="container">
        <div class="d-flex flex-row flex-wrap justify-content-center">
          @for (webPortal of webPortalData; track webPortal.portalId) {
            @if (webPortal.show) {
              <li class="col-12 col-md-6 col-xl-4 px-0 web-portal-list">
                <a
                  (click)="handleWebPortalRedirect(webPortal)"
                  (keydown.enter)="handleWebPortalRedirect(webPortal)"
                  (focus)="portalCardHoverIds[webPortal.portalId] = true"
                  (blur)="portalCardHoverIds[webPortal.portalId] = false"
                  tabindex="0"
                  id="{{ webPortal.portalId }}"
                >
                  <div
                    class="card shadow-sm text-center m-2 pok-card"
                    (mouseover)="portalCardHoverIds[webPortal.portalId] = true"
                    (mouseleave)="
                      portalCardHoverIds[webPortal.portalId] = false
                    "
                    [ngStyle]="{
                      'border-color': webPortal.color,
                      'background-color':
                        portalCardHoverIds[webPortal?.portalId] === true
                          ? getPokCardBackgroundColor(pokCardOpacity.Hovered)
                          : getPokCardBackgroundColor(pokCardOpacity.Default),
                    }"
                  >
                    <div
                      class="card-header pok-card-header"
                      [ngStyle]="{
                        'background-color': webPortal.color,
                        opacity: !backgroundUrlFromDb
                          ? pokCardOpacity.Hovered
                          : portalCardHoverIds[webPortal?.portalId] === true
                            ? pokCardOpacity.Hovered
                            : pokCardOpacity.Default,
                      }"
                    ></div>
                    <h5 class="card-title mb-0">
                      {{
                        getTranslatedWebPortalNameBySelectedInformationPortalTranslation(
                          webPortal
                        )
                      }}
                    </h5>
                    <div class="p-1 gk-scrollbar" tabindex="-1">
                      <p
                        class="card-text pok-card-text text-black"
                        [ngStyle]="{
                          opacity:
                            portalCardHoverIds[webPortal?.portalId] === true ||
                            !defaultThemeSelected
                              ? pokCardOpacity.Hovered
                              : pokCardOpacity.Default,
                        }"
                      >
                        <small
                          [innerHTML]="
                            getTranslatedWebDescriptionNameBySelectedInformationPortalTranslation(
                              webPortal
                            )
                          "
                        ></small>
                      </p>
                    </div>
                  </div>
                </a>
              </li>
            }
          }
        </div>
      </div>
    </div>
  </div>
  <app-department-footer></app-department-footer>
</div>

@if (backgroundUrlFromDb) {
  <div
    [style.background-image]="backgroundUrlFromDb"
    class="parallax-section-2"
  ></div>
}
